// extracted by mini-css-extract-plugin
export default {"container":"View_container__I+46O","row":"View_row__-bH-r","label":"View_label__LPnvl","last":"View_last__JE6Vk","link":"View_link__Axcmp"};